import { render, staticRenderFns } from "./SendRepairDetail.vue?vue&type=template&id=9f446bd2&scoped=true"
import script from "./SendRepairDetail.vue?vue&type=script&lang=js"
export * from "./SendRepairDetail.vue?vue&type=script&lang=js"
import style0 from "./SendRepairDetail.vue?vue&type=style&index=0&id=9f446bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f446bd2",
  null
  
)

export default component.exports